import { useTranslation } from 'react-i18next';
import { ProfileView } from '@/features/profile/ProfileView';

export function ProfilePage() {
  const { t } = useTranslation();
  return (
    <div>
      {/* No back button here: the booking-cancel flow could leave the router
          history in a state where the back arrow dead-ended. The profile is
          reachable via the bottom tab bar, so a back affordance isn't needed. */}
      <div className="flex items-center gap-3 py-2 mb-2">
        <h1 className="headline text-[18px] uppercase tracking-[0.02em]">{t('profile.title')}</h1>
      </div>
      <ProfileView />
    </div>
  );
}
